<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useElementVisibility, watchOnce } from '@vueuse/core';

interface AppLazyLoadEmits {
  (eventName: 'inner-element-visible'): void;
}

const emit = defineEmits<AppLazyLoadEmits>();

const innerComponentContainer = ref<HTMLElement | null>(null);

const isInnerComponentVisible = useElementVisibility(innerComponentContainer);

const shouldRenderInnerComponent = ref(isInnerComponentVisible.value);

onMounted(() => {
  if (isInnerComponentVisible.value) {
    return;
  }

  watchOnce(isInnerComponentVisible, () => {
    shouldRenderInnerComponent.value = true;
    emit('inner-element-visible');
  });
});
</script>

<template>
  <div ref="innerComponentContainer" class="app-lazy-load-component">
    <slot v-if="shouldRenderInnerComponent" />
  </div>
</template>

<style scoped lang="scss">
.app-lazy-load-component {
  width: 100%;
  height: 100%;
}
</style>
